document.addEventListener('DOMContentLoaded', function() {

    const elementsToHide = ['.needsclick']; // Add popup elements to this array to hide for robot testing

    const userAgent = window.navigator.userAgent;

    if(userAgent.includes('Arkhi Robot Testing')) {
        function waitForElm(selector) {
            return new Promise(resolve => {
                if (document.querySelector(selector)) {
                    return resolve(document.querySelector(selector));
                }
        
                const observer = new MutationObserver(mutations => {
                    if (document.querySelector(selector)) {
                        resolve(document.querySelector(selector));
                        // observer.disconnect();
                    }
                });
        
                observer.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            });
        }

        elementsToHide.forEach(element => {
            waitForElm(element).then((elm) => {
                elm.classList.add('robot-display-none');
            });
    });

    }
});
